<template>
    <v-flex v-if="priceAboveFreeShippingLimit" xs12 class="pb-0 merchant-offer-row">
        <p class="ma-0">
            <v-icon class="mr-1" color="black" size="20">check</v-icon>
            <strong>{{ 'Free shipping to AT & DE' | translation }}</strong>
        </p>
    </v-flex>
</template>

<script>
import Vue from 'vue';
import { mapState, mapActions } from 'vuex';

export default {
    name: 'ProductFreeShippingInfo',
    data() {
        return {
            offertProducts: [],
            productsSubscriber: null,
        };
    },
    props: {
        merchantId: {
            type: Number,
            default: null,
            required: true
        },
        merchantTotal: {
            type: Number,
            default: null,
            required: true
        }
    },
    computed: {
        customerCountryId() {
            let countryId = Vue.$country.getCountryID();
            this.getShippingPrices({
                merchant: parseInt(this.merchantId),
                country: countryId
            });
            return countryId;
        },
        priceAboveFreeShippingLimit() {
            let freeShippingLimit = 0;
            const customerCountryId = this.customerCountryId;
            if (customerCountryId && this.shippingPrices[this.merchantId]) {
                this.shippingPrices[this.merchantId].some(shippingPrice => {
                    if (
                        shippingPrice.country_id == customerCountryId &&
                        shippingPrice.value === 0
                    ) {
                        freeShippingLimit = shippingPrice.minimum;
                    }
                });
            }
            if(freeShippingLimit > 0 && freeShippingLimit <= this.merchantTotal){
                return true;
            }
            return false;
        },
        ...mapState('Product', ['shippingPrices']),
        ...mapState('Basket', ['products'])
    },
    methods: {
        ...mapActions('Product', ['getShippingPrices'])
    },
};
</script>
